import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import React, { useRef } from "react";

import { INITIAL_EDITOR_VALUE } from "../constants";

export function SetInitialStatePlugin({ initialState }: { initialState?: string }): React.ReactElement {
  const [editor] = useLexicalComposerContext();
  const hasSetInitialState = useRef(false);

  const setInitialState = useRef(() => {
    if (initialState && editor && !hasSetInitialState.current) {
      requestAnimationFrame(() => {
        const initialEditorState = editor.parseEditorState(initialState || INITIAL_EDITOR_VALUE);
        editor.setEditorState(initialEditorState);
        hasSetInitialState.current = true;
      });
    }
  });

  if (initialState && editor && !hasSetInitialState.current) {
    setInitialState.current();
  }

  return <></>;
}
